import { createContext, useContext } from 'react';
import type { CreateDefaults } from '../features/tasks/CreateTaskDialog';

export type ShellActions = {
  /** Нова задача (Q): діалог із попередньо заповненими полями. */
  openCreateTask: (defaults?: CreateDefaults) => void;
  /** Картка задачі поверх поточного подання (?task=…). */
  openTask: (id: string) => void;
  closeTask: () => void;
  openPalette: () => void;
  openShortcuts: () => void;
  focusSearch: () => void;
};

export const ShellContext = createContext<ShellActions | null>(null);

export function useShell(): ShellActions {
  const c = useContext(ShellContext);
  if (!c) throw new Error('ShellContext відсутній');
  return c;
}
